import useBoardContentObject from "./useBoardContentObject";

import {IBoardWidget} from "../types/IBoardWidget";
import {IBoardObject} from "../types/IBoardObject";
import {IBoardObjectNode} from "../types/IBoardObjectNode";
import {IBoardWidgetNode} from "../types/IBoardWidgetNode";

const useBoardContentWidget = () => {
  const {nodesFor} = useBoardContentObject();

  const newWidget = (): IBoardWidget => {
    return {
      classifications: [],
      columnSpan: 0,
      contentId: 0,
      defineGroup: false,
      defineNodes: false,
      domain: '',
      id: 0,
      linkContentId: 0,
      linkContent: null,
      name: '',
      nodes: [],
      pinned: [],
      rowSpan: 0,
      setup: '',
      templateId: 0,
      currencySelection: false,
      enableLevelSelect: false,
      suppressLocalCurrency: false,
      singlePeriod: false,
      templateWidgetId: 0,
      type: '',
      visible: true,
    };
  }

  const nodesExcludedForObject = (widget: IBoardWidget, objectPath: string) => {
    if (!widget.objectNodeLookup)
      buildObjectNodeLookup(widget);

    return widget.objectNodeExcludeLookup[objectPath] || {nodes: [], idLookup: {}};
  };

  const widgetSetup = (widget: IBoardWidget) => {
    if (widget && typeof widget.setup === 'string') {
      return JSON.parse(widget.setup);
    } else {
      return widget.setup;
    }
  }

  const loadNodesForObject = (widget: IBoardWidget, nodes: IBoardWidgetNode[], contentObject: IBoardObject) => {
    let lookupSync = {};
    let lookup = nodes.filter((item) => {
      return item.objectPath === contentObject.objectPath;
    });

    const setupJson = JSON.parse(widget.setup);
    if (setupJson.sliceGroup) {
      let groupNodes: any = nodesFor(contentObject.nodes, parseInt(setupJson.sliceGroup) || 0);
      groupNodes.forEach((groupNode) => {
        _addUpdateNode(nodes, contentObject, groupNode, true, lookup);
        if (groupNode.id) {
          lookupSync[groupNode.id] = true;
        }
      });
    } else {
      let objNodes = contentObject.nodes.filter((item) => {
        return !item.isDescendent && !item.exclude;
      });
      objNodes.forEach((node) => {
        _addUpdateNode(nodes, contentObject, node, false, lookup);
        if (node.id) {
          lookupSync[node.id] = true;
        }
      });
    }

    for (let i = 0; i < lookup.length; i++) {
      let ln = lookup[i];
      if (ln.nodeId && !lookupSync[ln.nodeId]) nodes.splice(nodes.indexOf(ln), 1);
    }
  };

  const _addUpdateNode = (nodes: IBoardWidgetNode[], contentObject: IBoardObject, node: IBoardObjectNode, isGroup: boolean, lookup: any) => {
    let objectNode = lookup.find((item) => {
      return item.nodeId === node.id;
    });

    if (!objectNode) {
      objectNode = {
        objectPath: contentObject.objectPath,
        nodeId: node.id,
        name: node.name,
        fullName: node.fullName,
        isGroup: isGroup,
        exclude: false,
      };

      nodes.push(objectNode);
      lookup.push(objectNode);
    } else {
      objectNode.name = node.name;
      objectNode.fullName = node.fullName;
    }

    return objectNode;
  };

  const buildObjectNodeLookup = (widget: IBoardWidget) => {
    widget.objectNodeLookup = {};
    widget.objectNodeExcludeLookup = {};

    if(!widget.nodes){
      return;
    }

    for (let i = 0; i < widget.nodes.length; i++) {
      let node = widget.nodes[i];
      let objectNodes = widget.objectNodeLookup[node.objectPath];
      if (!objectNodes) {
        widget.objectNodeLookup[node.objectPath] = [node];

        let lookup: any = {nodes: [], idLookup: {}};
        if (node.exclude) {
          lookup.nodes.push(node);
          lookup.idLookup[node.nodeId] = true;
        }
        widget.objectNodeExcludeLookup[node.objectPath] = lookup;
      } else {
        objectNodes.push(node);
        if (node.exclude) {
          let exlookup = widget.objectNodeExcludeLookup[node.objectPath];
          exlookup.nodes.push(node);
          exlookup.idLookup[node.nodeId] = true;
        }
      }
    }
  };

  const fromTemplate = (templateWidget: IBoardWidget): IBoardWidget => {
    let widget = newWidget();

    widget.templateWidgetId = templateWidget.id;
    widget.name = templateWidget.name;
    widget.type = templateWidget.type;
    widget.rowSpan = templateWidget.rowSpan;
    widget.columnSpan = templateWidget.columnSpan;
    widget.setup = templateWidget.setup;

    return widget;
  }

  return {
    newWidget,
    fromTemplate,
    buildObjectNodeLookup,
    loadNodesForObject,
    nodesExcludedForObject,
    widgetSetup,
  }
}

export default useBoardContentWidget;